import React, { ReactNode, FC } from "react";
import styled from "styled-components";
import tw from "twin.macro";

type props = {
  text?: string;
  children?: ReactNode;
  type?: "button" | "submit" | "reset" | undefined;
  className?: string;
  onClick?: () => void;
  padding?: boolean;
  background?: string;
  color?: string;
  fontSize?: number;
  paddingvalues?: string;
  opacity?: number;
  isfull?: boolean;
  icon?: React.ReactElement | string;
  ispadding?: boolean;
  paddingvals?: string;
  formWidthButton?: string;
};

const ButtonStyles = styled.button<{
  background?: string;
  color?: string;
  padding?: boolean;
  fontSize?: number;
  opacity?: number;
  isfull?: boolean;
  icon?: React.ReactElement | string;
  ispadding?: boolean;
  paddingvals?: string;
  formWidthButton?: string;
}>`
  background: ${({ background }) => (background ? background : "#fff")};
  color: ${({ color }) => (color ? color : "#000")};
  ${tw`flex items-center justify-center gap-3 font-medium rounded-full font-clash outline-0`}

  padding: ${({ ispadding, paddingvals }) =>
    ispadding ? `${paddingvals}` : " 14.5px 30px"};
  width: ${({ isfull }) => isfull && "100%"};
  &:hover {
    ${tw`transition-all duration-700 ease-in-out delay-300 opacity-70`}
  }
  opacity: ${({ opacity }) => (opacity ? `0.5` : "")};
  width: ${({ formWidthButton }) => formWidthButton || ""};

  @media screen and (max-width: 1024px) {
    padding: ${({ paddingvals }) => `${paddingvals}` || "30px 35px;"};
  }

  @media screen and (max-width: 768px) {
    padding: ${({ paddingvals }) => `${paddingvals}` || "12px 35px;"};
  }
`;

export const Button: FC<props> = ({
  children,
  type,
  onClick,
  padding,
  fontSize,
  opacity,
  background,
  color,
  isfull,
  icon,
  ispadding,
  paddingvals,
  formWidthButton,
}) => {
  return (
    <ButtonStyles
      type={type}
      onClick={onClick}
      padding={padding}
      fontSize={fontSize}
      opacity={opacity}
      background={background}
      color={color}
      isfull={isfull}
      icon={icon}
      ispadding={ispadding}
      paddingvals={paddingvals}
      formWidthButton={formWidthButton}
    >
      {children}
      {icon}
    </ButtonStyles>
  );
};
